module.exports = __webpack_public_path__ + "img/circle1.9def128f.png";